/**
 * スムーススクロールでターゲット要素までスクロール
 * @param targetId - スクロール先の要素ID（#は含まない）
 * @param delay - スクロール実行までの遅延時間（ミリ秒）
 */
export function scrollToElement(targetId: string, delay: number = 100): void {
  if (!targetId) {
    // IDが空の場合はページトップへ
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return;
  }

  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    // ヘッダーの高さを考慮したオフセット（必要に応じて調整）
    const headerHeight = document.querySelector('.js-header')?.clientHeight || 0;
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    
    // 遅延させてスクロールを実行（メニュー閉じるアニメーションと競合しないように）
    setTimeout(() => {
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }, delay);
  }
}

/**
 * URLハッシュを更新（履歴に追加）
 * @param hash - 設定するハッシュ値（#を含む）
 */
export function updateUrlHash(hash: string): void {
  history.pushState(null, '', hash);
}